import React, { createContext, useState } from 'react'

export interface ProducersObjectType{
  id: number | null
  fullName: string
  position: string
  costPerHour: number | null
  costPerExtraHour: number | null
  machines: string
}

const initialState:ProducersObjectType = {
  id:null,
  costPerExtraHour:null,
  costPerHour:null,
  fullName:'',
  machines:'',
  position:''
}

interface ProductionUsersContextProps{
  productionUser:ProducersObjectType
  setProductionUser:React.Dispatch<React.SetStateAction<ProducersObjectType>>
}

export const ProductionUserContext = createContext<ProductionUsersContextProps>({
  productionUser:initialState,
  setProductionUser:() => {return}
})

export const ProductionUserProvider:React.FC<any> = ({children}) => {
  const [productionUser, productionUsers] = useState<ProducersObjectType>(initialState)

  return(
    <ProductionUserContext.Provider value={{
      productionUser: productionUser,
      setProductionUser: productionUsers
    }}
    >
      {children}
  </ProductionUserContext.Provider>
  )
}